import '@content/foundations/src/index'
import asWebComponent from '../../asWebComponent'
import HeroHome from './HeroHome'

export default asWebComponent(HeroHome, 'nb-hero-home', ['data'])
